var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizzImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9187 8.76634C13.5742 7.75745 7.24089 13.2108 7.66645 20.4441M4.88867 6.55523C4.88867 7.1446 5.1228 7.70983 5.53955 8.12658C5.95629 8.54333 6.52152 8.77745 7.11089 8.77745C7.70026 8.77745 8.26549 8.54333 8.68224 8.12658C9.09899 7.70983 9.33312 7.1446 9.33312 6.55523C9.33312 5.96586 9.09899 5.40063 8.68224 4.98388C8.26549 4.56713 7.70026 4.33301 7.11089 4.33301C6.52152 4.33301 5.95629 4.56713 5.53955 4.98388C5.1228 5.40063 4.88867 5.96586 4.88867 6.55523Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1853C4.08889 11.7575 6.86111 13.2497 8.36 15.6297",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.11111C1 5.62222 1 4.37778 1.48444 3.42667C1.91054 2.59043 2.59043 1.91054 3.42667 1.48444C4.37778 1 5.62222 1 8.11111 1H13.8889C16.3778 1 17.6222 1 18.5733 1.48444C19.4096 1.91054 20.0895 2.59043 20.5156 3.42667C21 4.37778 21 5.62222 21 8.11111V13.8889C21 16.3778 21 17.6222 20.5156 18.5733C20.0895 19.4096 19.4096 20.0895 18.5733 20.5156C17.6222 21 16.3778 21 13.8889 21H8.11111C5.62222 21 4.37778 21 3.42667 20.5156C2.59043 20.0895 1.91054 19.4096 1.48444 18.5733C1 17.6222 1 16.3778 1 13.8889V8.11111Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizzImg);
export default __webpack_public_path__ + "static/media/quizzImg.e45323b0e75c6a1d54dd5863e600c858.svg";
export { ForwardRef as ReactComponent };